/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import axios from 'axios';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import { useHistory, useParams } from 'react-router-dom';
import { parseISO } from 'date-fns';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Loading from '~/components/Loading';
import InputMask from '~/components/InputMask';
import Input from '~/components/Input';
import Representative, { IRepresentative } from './Representative';
import Toast from '~/utils/toast';

interface IOrganizerUser {
  id: number;
  user: {
    id: number;
    name: string;
    email: string;
    additionalInformation: {
      id: number;
      document: string;
      birthdate: string;
      gender: string;
      address: {
        id: number;
        street: string;
        number: number;
        neighborhood: string;
        city: string;
        state: string;
        country: string;
        complement: string;
        zip_code: string;
      };
    };
  };
}

interface IOrganizerResponse {
  id: number;
  name: string;
  company: {
    id: number;
    document: string;
    name: string;
    fantasy_name: string;
    support_email: string;
    finance_email: string;
    address: {
      id: number;
      street: string;
      number: number;
      neighborhood: string;
      city: string;
      state: string;
      country: string;
      complement: string;
      zip_code: string;
    };
  };
  organizersUsers: IOrganizerUser[];
}

interface IFormData {
  organizer_id: number;
  company_id: number;
  name: string;
  cnpj: string;
  company_name: string;
  fantasy_name: string;
  support_email: string;
  finance_email: string;
  address_id: number;
  zipcode: string;
  street: string;
  number: string;
  city: string;
  state: string;
  neighborhood: string;
  complement: string;
}

interface IParams {
  organizer_id: string;
}

const UpdateOrganizer: React.FC = () => {
  const params = useParams<IParams>();
  const [progressNumber, setProgressNumber] = useState(1);
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [fantasyName, setFantasyName] = useState('');
  const [supportEmail, setSupportEmail] = useState('');
  const [financeEmail, setFinanceEmail] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [complement, setComplement] = useState('');
  const [oldRepresentatives, setOldRepresentatives] = useState<
    IRepresentative[]
  >([]);
  const [representatives, setRepresentatives] = useState<IRepresentative[]>([]);
  const [organizer, setOrganizer] = useState({} as IFormData);
  const [documentError, setDocumentError] = useState(false);

  const progress = useMemo(() => [1, 2, 3], []);

  const textProgress = useMemo(
    () => [
      { name: 'Empresa' },
      { name: 'Endereço' },
      { name: 'Representantes' },
    ],
    []
  );

  useEffect(() => {
    api
      .get<IOrganizerResponse>(`/organizers/${params.organizer_id}`)
      .then((response) => {
        const data = response.data.organizersUsers.map<IRepresentative>(
          (organizerUser) => {
            return {
              id: organizerUser.user.id,
              organizerUser_id: organizerUser.id,
              user_id: organizerUser.user.id,
              additionalInformation_id:
                organizerUser.user.additionalInformation?.id,
              name: organizerUser.user.name,
              email: organizerUser.user.email,
              cpf: organizerUser.user.additionalInformation?.document,
              birthdate: organizerUser.user.additionalInformation?.birthdate
                ? parseISO(organizerUser.user.additionalInformation.birthdate)
                : new Date(),
              gender: organizerUser.user.additionalInformation?.gender,
              address_id: organizerUser.user.additionalInformation?.address?.id,
              zipcode:
                organizerUser.user.additionalInformation?.address?.zip_code,
              street: organizerUser.user.additionalInformation?.address?.street,
              number:
                organizerUser.user.additionalInformation?.address?.number.toString(),
              neighborhood:
                organizerUser.user.additionalInformation?.address?.neighborhood,
              city: organizerUser.user.additionalInformation?.address?.city,
              state: organizerUser.user.additionalInformation?.address?.state,
              country:
                organizerUser.user.additionalInformation?.address?.country,
              complement:
                organizerUser.user.additionalInformation?.address?.complement,
            };
          }
        );
        setOldRepresentatives(data);
        setRepresentatives(data);
        setCompanyName(response.data.company.name);
        setFantasyName(response.data.company.fantasy_name);
        setSupportEmail(response.data.company.support_email);
        setFinanceEmail(response.data.company.finance_email);
        setZipcode(response.data.company.address.zip_code);
        setStreet(response.data.company.address.street);
        setNumber(response.data.company.address.number.toString());
        setState(response.data.company.address.state);
        setCity(response.data.company.address.city);
        setNeighborhood(response.data.company.address.neighborhood);
        setComplement(response.data.company.address.complement);
        setOrganizer({
          organizer_id: response.data.id,
          company_id: response.data.company.id,
          name: response.data.name,
          cnpj: response.data.company.document,
          company_name: response.data.company.name,
          fantasy_name: response.data.company.fantasy_name,
          support_email: response.data.company.support_email,
          finance_email: response.data.company.finance_email,
          address_id: response.data.company.address.id,
          zipcode: response.data.company.address.zip_code,
          street: response.data.company.address.street,
          number: response.data.company.address.number.toString(),
          city: response.data.company.address.city,
          state: response.data.company.address.state,
          neighborhood: response.data.company.address.neighborhood,
          complement: response.data.company.address.complement,
        });
      });
  }, [params.organizer_id]);

  const handleClickNext = useCallback((stepSelected) => {
    setProgressNumber(stepSelected);
  }, []);

  const handleChangeCnpj = useCallback(async (e) => {
    const { value } = e.target;
    if (value.length === 18) {
      const response = await axios.get(
        `https://api-publica.speedio.com.br/buscarcnpj?cnpj=${value
          .replaceAll('.', '')
          .replaceAll('-', '')
          .replaceAll('/', '')}`
      );
      setCompanyName(response.data['RAZAO SOCIAL']);
      setFantasyName(response.data['NOME FANTASIA']);
      setSupportEmail(response.data.EMAIL);
      setZipcode(response.data.CEP);
      setStreet(
        `${response.data['TIPO LOGRADOURO']} ${response.data.LOGRADOURO}`
      );
      setNumber(response.data.NUMERO);
      setState(response.data.UF);
      setCity(response.data.MUNICIPIO);
      setNeighborhood(response.data.BAIRRO);
      setComplement(response.data.COMPLEMENTO);
    }
  }, []);

  const handleOrganizerName = useCallback((e) => {
    setCompanyName(e.target.value);
  }, []);

  const handleOrganizerFantasy = useCallback((e) => {
    setFantasyName(e.target.value);
  }, []);

  const handleSuppotyEmail = useCallback((e) => {
    setSupportEmail(e.target.value);
  }, []);

  const handleFinanceEmail = useCallback((e) => {
    setFinanceEmail(e.target.value);
  }, []);

  const handleChangeZipCode = useCallback(async (e) => {
    const { value } = e.target;
    setZipcode(value);

    if (value.length === 9) {
      const response = await axios.get(
        `https://viacep.com.br/ws/${value}/json/`
      );
      setStreet(response.data.logradouro);
      setNumber('');
      setState(response.data.uf);
      setCity(response.data.localidade);
      setNeighborhood(response.data.bairro);
      setComplement(response.data.complemento);
    }
  }, []);

  const handleChangeStreet = useCallback((e) => {
    setStreet(e.target.value);
  }, []);

  const handleChangeNumber = useCallback((e) => {
    setNumber(e.target.value);
  }, []);

  const handleChangeCity = useCallback((e) => {
    setCity(e.target.value);
  }, []);

  const handleChangeState = useCallback((e) => {
    setState(e.target.value);
  }, []);

  const handleChangeNeighborhood = useCallback((e) => {
    setNeighborhood(e.target.value);
  }, []);

  const handleChangeComplement = useCallback((e) => {
    setComplement(e.target.value);
  }, []);

  const handleChangeRepresentatives = useCallback((data) => {
    setRepresentatives(data);
  }, []);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('O nome do organizador é obrigatório'),
          cnpj: Yup.string().required('O CNPJ é obrigatório'),
          company_name: Yup.string().required('A razão social é obrigatória'),
          fantasy_name: Yup.string().required('O nome fantasia é obrigatório'),
          support_email: Yup.string().required(
            'O e-mail de suporte é obrigatório'
          ),
          finance_email: Yup.string().required(
            'O e-mail do financeiro é obrigatório'
          ),
          zipcode: Yup.string().required('O CEP é obrigatório'),
          street: Yup.string().required('A rua é obrigatória'),
          number: Yup.string().required('O número é obrigatório'),
          city: Yup.string().required('A cidade é obrigatória'),
          state: Yup.string().required('O estado é obrigatório'),
          neighborhood: Yup.string().required('O bairro é obrigatório'),
          complement: Yup.string(),
          ...representatives.reduce((previous, representative) => {
            const newSchema = previous;
            newSchema[`email_${representative.id}`] = Yup.string()
              .email()
              .required('O e-mail é obrigatório')
              .test(
                'checkIfEmailExists',
                `Esse e-mail já foi cadastrado`,
                async () => {
                  const response = await api.get(
                    `users/emails/${representative.email}`
                  );

                  return (
                    !response.data ||
                    response.data.id === representative.id ||
                    !response.data.profilesUsers.some(
                      (profileUser: any) =>
                        profileUser.profile.name === 'Organizador'
                    )
                  );
                }
              );
            newSchema[`name_${representative.id}`] = Yup.string().required(
              'O nome é obrigatório'
            );
            newSchema[`cpf_${representative.id}`] = Yup.string().required(
              'O CPF é obrigatório'
            );
            newSchema[`birthdate_${representative.id}`] = Yup.string().required(
              'O nascimento é obrigatório'
            );
            newSchema[`gender_${representative.id}`] = Yup.string().required(
              'O gênero é obrigatório'
            );
            newSchema[`zipcode_${representative.id}`] = Yup.string().required(
              'O CEP é obrigatório'
            );
            newSchema[`street_${representative.id}`] = Yup.string().required(
              'O endereço é obrigatório'
            );
            newSchema[`number_${representative.id}`] = Yup.string().required(
              'O número é obrigatório'
            );
            newSchema[`city_${representative.id}`] = Yup.string().required(
              'A cidade é obrigatória'
            );
            newSchema[`state_${representative.id}`] = Yup.string().required(
              'O estado é obrigatório'
            );
            newSchema[`neighborhood_${representative.id}`] =
              Yup.string().required('O bairro é obrigatório');
            return newSchema;
          }, {} as { [key: string]: Yup.StringSchema<string | undefined, Record<string, any>, string | undefined> }),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const addressFormData = {
          zip_code: data.zipcode,
          street: data.street,
          number: data.number,
          neighborhood: data.neighborhood,
          city: data.city,
          state: data.state,
          country: 'Brasil',
          complement: data.complement,
        };

        if (organizer.address_id) {
          await api.put(`addresses/${organizer.address_id}`, addressFormData);
        } else {
          await api.post(`addresses`, addressFormData);
        }

        const companyFormData = {
          address_id: organizer.address_id,
          document: data.cnpj,
          name: data.company_name,
          fantasy_name: data.fantasy_name,
          support_email: data.support_email,
          finance_email: data.finance_email,
        };

        await api.put(`companies/${organizer.company_id}`, companyFormData);

        const organizerFormData = {
          company_id: organizer.company_id,
          name: data.name,
        };

        const responseOrganizer = await api.put(
          `organizers/${organizer.organizer_id}`,
          organizerFormData
        );

        const deletedRepresentatives = oldRepresentatives.filter(
          (oldRepresentative) =>
            !representatives.some(
              (representative) => oldRepresentative.id === representative.id
            )
        );

        for (const representative of deletedRepresentatives) {
          await api.delete(
            `organizers-users/${representative.organizerUser_id}`
          );
        }

        const updatedRepresentatives = representatives.filter(
          (representative) =>
            oldRepresentatives.some(
              (oldRepresentative) => oldRepresentative.id === representative.id
            )
        );

        for (const representative of updatedRepresentatives) {
          const representativeAddressFormData = {
            zip_code: representative.zipcode,
            street: representative.street,
            number: representative.number,
            neighborhood: representative.neighborhood,
            city: representative.city,
            state: representative.state,
            country: 'Brasil',
            complement: representative.complement,
          };

          let responseRepresentativeAddressId = representative.address_id;
          if (responseRepresentativeAddressId) {
            await api.put(
              `addresses/${responseRepresentativeAddressId}`,
              representativeAddressFormData
            );
          } else {
            const responseRepresentativeAddress = await api.post(
              `addresses`,
              representativeAddressFormData
            );

            responseRepresentativeAddressId =
              responseRepresentativeAddress.data.id;
          }

          const representativeFormData = {
            name: representative.name,
            email: representative.email,
          };

          await api.put(
            `users/organizers/${representative.user_id}`,
            representativeFormData
          );

          const additionalInformationsFormData = {
            user_id: representative.user_id,
            address_id: responseRepresentativeAddressId,
            document: representative.cpf,
            birthdate: representative.birthdate.toISOString(),
            gender: representative.gender,
            verified: true,
          };

          if (representative.additionalInformation_id) {
            await api.put(
              `additional-informations/${representative.additionalInformation_id}`,
              additionalInformationsFormData
            );
          } else {
            await api.post(
              `additional-informations`,
              additionalInformationsFormData
            );
          }
        }

        const newRepresentatives = representatives.filter(
          (representative) =>
            !oldRepresentatives.some(
              (oldRepresentative) => oldRepresentative.id === representative.id
            )
        );

        for (const representative of newRepresentatives) {
          const representativeAddressFormData = {
            zip_code: representative.zipcode,
            street: representative.street,
            number: representative.number,
            neighborhood: representative.neighborhood,
            city: representative.city,
            state: representative.state,
            country: 'Brasil',
            complement: representative.complement,
          };

          const responseRepresentativeAddress = await api.post(
            'addresses',
            representativeAddressFormData
          );

          const representativeFormData = {
            organizer_id: responseOrganizer.data.id,
            address_id: responseRepresentativeAddress.data.id,
            name: representative.name,
            email: representative.email,
            document: representative.cpf,
            birthdate: representative.birthdate.toISOString(),
            gender: representative.gender,
          };

          await api.post('users/organizers', representativeFormData);
        }

        Toast.fire({
          icon: 'success',
          iconColor: '#ff6900',
          title: 'Organizador editado com sucesso!',
        });

        history.push(`${process.env.PUBLIC_URL}/organizadores`);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);

          const keys = Object.keys(errors);

          if (
            keys.find(
              (key) =>
                key === 'cnpj' ||
                key === 'company_name' ||
                key === 'fantasy_name' ||
                key === 'support_email' ||
                key === 'finance_email'
            )
          ) {
            setProgressNumber(1);
          } else if (
            keys.find(
              (key) =>
                key === 'zipcode' ||
                key === 'street' ||
                key === 'number' ||
                key === 'city' ||
                key === 'state' ||
                key === 'neighborhood'
            )
          ) {
            setProgressNumber(2);
          }

          window.scrollTo(0, 0);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      } finally {
        setLoading(false);
      }
    },
    [
      history,
      oldRepresentatives,
      organizer.address_id,
      organizer.company_id,
      organizer.organizer_id,
      representatives,
    ]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [progressNumber]);

  return (
    <Container>
      <div className="container-fluid">
        <div>
          <div className="row">
            <div className="col-12 px-0">
              <div className="bg-white d-flex justify-content-between align-items-center p-4">
                <h1 className="mb-0">Editar Organizador</h1>
              </div>
            </div>
            <div className="col-12 px-0">
              <div className="bg-white p-4 p-lg-5 mt-3">
                <div className="row justify-content-center">
                  <div className="col-xl-10 col-xxl-9">
                    <div className="d-flex justify-content-center align-items-center">
                      {progress.map((index) => (
                        <>
                          <div>
                            <div className="pe-none btn bg-transparent border-0 position-relative">
                              <span
                                className={`${
                                  index < progressNumber + 1
                                    ? 'circle-active'
                                    : 'circle'
                                }`}
                              >
                                {index}
                              </span>

                              <span
                                className={`text ${
                                  index < progressNumber + 1
                                    ? 'text-active'
                                    : ''
                                }`}
                              >
                                {textProgress[index - 1].name}
                              </span>
                            </div>
                          </div>
                          {index !== progress.length && (
                            <hr
                              className={`${
                                index < progressNumber + 1 && 'hr-active'
                              } w-22 my-0 mx-2`}
                            />
                          )}
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <Form
                  ref={formRef}
                  onSubmit={handleSubmit}
                  className="row justify-content-center"
                  initialData={organizer}
                >
                  <div className="col-lg-9 col-xl-7 col-xxl-6">
                    <div
                      className={`${
                        progressNumber === 1 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <h2 className="h4 fw-semibold pt-4 mt-5 mb-4">
                        1 - Empresa
                      </h2>
                      <div className="row">
                        <div className="col-12">
                          <h3 className="h6 fw-normal">Nome do organizador</h3>
                          <Input name="name" className="input" />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">CNPJ</h3>
                          <InputMask
                            kind="cnpj"
                            name="cnpj"
                            onChange={(e) => handleChangeCnpj(e)}
                            className="input"
                            value={organizer.cnpj}
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">Razão Social</h3>
                          <Input
                            name="company_name"
                            value={companyName}
                            onChange={(e) => handleOrganizerName(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">Nome Fantasia</h3>
                          <Input
                            name="fantasy_name"
                            value={fantasyName}
                            onChange={(e) => handleOrganizerFantasy(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">
                            E-mail de Suporte (problemas e dúvidas dos usuários)
                          </h3>
                          <Input
                            type="email"
                            name="support_email"
                            value={supportEmail}
                            onChange={(e) => handleSuppotyEmail(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-12">
                          <h3 className="h6 fw-normal mt-3">
                            E-mail do financeiro (Saques/depósitos)
                          </h3>
                          <Input
                            type="email"
                            name="finance_email"
                            value={financeEmail}
                            onChange={(e) => handleFinanceEmail(e)}
                            className="input"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        progressNumber === 2 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <h2 className="h4 fw-semibold pt-4 mt-5 mb-4">
                        2 - Endereço
                      </h2>
                      <div className="row">
                        <div className="col-lg-4">
                          <h3 className="h6 fw-normal">CEP</h3>
                          <InputMask
                            kind="zip-code"
                            name="zipcode"
                            value={zipcode}
                            onChange={(e) => handleChangeZipCode(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-8 mt-3 mt-lg-0">
                          <h3 className="h6 fw-normal">Endereço</h3>
                          <Input
                            name="street"
                            value={street}
                            onChange={(e) => handleChangeStreet(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-2 mt-3">
                          <h3 className="h6 fw-normal">Número</h3>
                          <Input
                            name="number"
                            value={number}
                            onChange={(e) => handleChangeNumber(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Cidade</h3>
                          <Input
                            name="city"
                            value={city}
                            onChange={(e) => handleChangeCity(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Estado</h3>
                          <Input
                            name="state"
                            value={state}
                            onChange={(e) => handleChangeState(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-5 mt-3">
                          <h3 className="h6 fw-normal">Bairro</h3>
                          <Input
                            name="neighborhood"
                            value={neighborhood}
                            onChange={(e) => handleChangeNeighborhood(e)}
                            className="input"
                          />
                        </div>
                        <div className="col-lg-7 mt-3">
                          <h3 className="h6 fw-normal">Complemento</h3>
                          <Input
                            name="complement"
                            value={complement}
                            onChange={(e) => handleChangeComplement(e)}
                            className="input"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        progressNumber === 3 ? 'd-block' : 'd-none'
                      }`}
                    >
                      <h2 className="h4 fw-semibold pt-4 mt-5 mb-4">
                        3 - Representantes
                      </h2>

                      <Representative
                        representatives={representatives}
                        onChange={handleChangeRepresentatives}
                        setDocumentError={setDocumentError}
                      />
                    </div>
                  </div>
                </Form>
                <div className="row justify-content-center">
                  <div
                    className={`col-lg-6 d-flex mt-4 ${
                      progressNumber === 3
                        ? 'justify-content-end'
                        : 'justify-content-center'
                    }`}
                  >
                    {progressNumber !== 1 && (
                      <button
                        type="button"
                        onClick={() => setProgressNumber(progressNumber - 1)}
                        className="mb-0 me-4 h6 fw-normal btn-back px-5 py-2 mt-2"
                      >
                        Anterior
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        progressNumber === 3
                          ? formRef.current?.submitForm()
                          : handleClickNext(progressNumber + 1);
                      }}
                      className="mb-0 h6 fw-normal text-white btn-new px-5 py-2 mt-2"
                      disabled={documentError}
                      style={{ opacity: documentError ? 0.6 : 1 }}
                    >
                      {progressNumber === 3 ? 'Salvar' : 'Próximo'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading active={loading} text="Salvando..." />
    </Container>
  );
};

export default UpdateOrganizer;
